import React from 'react';

interface FormProps {
  formData: any;
  onChange: (id: string, value: string) => void;
}

export const DoctorIntake: React.FC<FormProps> = ({ formData, onChange }) => {
  return (
    <div className="space-y-4">
      {/* 🟢 NEW: Explicit Patient Demographics for the Prescription */}
      <div className="grid grid-cols-2 gap-4">
        <div className="flex flex-col gap-1.5">
          <label className="text-sm font-medium text-gray-700">Patient Age <span className="text-red-500">*</span></label>
          <input 
            type="text" 
            placeholder="e.g., 32" 
            value={formData.age || ''} 
            onChange={(e) => onChange('age', e.target.value)}
            className="w-full px-3 py-2 border border-gray-200 rounded-lg outline-none focus:ring-2 focus:ring-blue-500 text-sm" 
          />
        </div>
        <div className="flex flex-col gap-1.5">
          <label className="text-sm font-medium text-gray-700">Patient Gender <span className="text-red-500">*</span></label>
          <select 
            value={formData.gender || ''} 
            onChange={(e) => onChange('gender', e.target.value)}
            className="w-full px-3 py-2 border border-gray-200 rounded-lg outline-none focus:ring-2 focus:ring-blue-500 text-sm bg-white"
          >
            <option value="" disabled>Select...</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Other">Other</option>
          </select>
        </div>
      </div>

      {/* Existing Medical Questions */}
      <div className="flex flex-col gap-1.5">
        <label className="text-sm font-medium text-gray-700">Briefly describe your symptoms <span className="text-red-500">*</span></label>
        <textarea 
          rows={3} 
          placeholder="E.g., fever, headache, stomach pain..." 
          value={formData.symptoms || ''} 
          onChange={(e) => onChange('symptoms', e.target.value)}
          className="w-full px-3 py-2 border border-gray-200 rounded-lg outline-none focus:ring-2 focus:ring-blue-500 text-sm resize-none" 
        />
      </div>
      
      <div className="flex flex-col gap-1.5">
        <label className="text-sm font-medium text-gray-700">How long have you had these symptoms? <span className="text-red-500">*</span></label>
        <input 
          type="text" 
          placeholder="E.g., 2 days, 1 week" 
          value={formData.duration || ''} 
          onChange={(e) => onChange('duration', e.target.value)}
          className="w-full px-3 py-2 border border-gray-200 rounded-lg outline-none focus:ring-2 focus:ring-blue-500 text-sm" 
        />
      </div>
      
      <div className="flex flex-col gap-1.5">
        <label className="text-sm font-medium text-gray-700">Any current medications?</label>
        <input 
          type="text" 
          placeholder="List any medicines you are taking currently" 
          value={formData.medications || ''} 
          onChange={(e) => onChange('medications', e.target.value)}
          className="w-full px-3 py-2 border border-gray-200 rounded-lg outline-none focus:ring-2 focus:ring-blue-500 text-sm" 
        />
      </div>
    </div>
  );
};